import { render, staticRenderFns } from "./legalProceedingsDetail.vue?vue&type=template&id=53d909a8&scoped=true&"
import script from "./legalProceedingsDetail.vue?vue&type=script&lang=js&"
export * from "./legalProceedingsDetail.vue?vue&type=script&lang=js&"
import style0 from "./legalProceedingsDetail.vue?vue&type=style&index=0&id=53d909a8&prod&scoped=true&lang=css&"
import style1 from "./legalProceedingsDetail.vue?vue&type=style&index=1&id=53d909a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d909a8",
  null
  
)

export default component.exports